import {IServiceError} from "@/core/service/types";

export const internalServerError: IServiceError = {
    message: "Internal Server Error", statusCode: 500
}